<template>
  <div class="info-block">
    <div class="wd-my-4 wd-px-5">
      <div class="wd-text-xl wd-font-medium wd-mb-3">{{ $t('branch_info') }}</div>
      <div class="wd-overflow-hidden wd-mb-2" :class="[introExpandStatus ? 'wd-max-h-unset' : 'wd-max-h-66px']">
        <p ref="introInfo" class="ma-0 wd-whitespace-pre-wrap">{{ intro }}</p>
      </div>
      <v-btn
        v-if="isShowMoreInfoBtn"
        class="wd-block wd-m-auto wd-text-obase"
        color="orange50"
        height="32"
        variant="text"
        @click="introExpandStatus = true"
      >
        {{ $t('branch_info_more') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default defineComponent({
  name: 'BranchIntro',
  props: {
    intro: { type: String, default: '' },
  },
  setup() {
    const introExpandStatus = ref(false)
    const introInfo = ref(null)
    const isShowMoreInfoBtn = computed(() => {
      if (!introInfo.value) {
        return true
      }
      return !introExpandStatus.value && introInfo.value.getBoundingClientRect().height > 66
    })

    return {
      introExpandStatus,
      introInfo,
      isShowMoreInfoBtn,
    }
  },
})
</script>
